module.exports = __webpack_public_path__ + "media/shulk.44a6933e.wav";